






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelSaraiva} from '@/model/resource/ResponsavelSaraiva'
import {InputResponsavelSaraivaSchema} from '@/schema/resource/ResponsavelSaraiva/InputResponsavelSaraivaSchema'

@Component
export default class PersistResponsavelSaraivaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelSaraivaSchema()
  responsavelSaraiva = new ResponsavelSaraiva()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelSaraiva.getResponsavelSaraiva(id)
    }

    $.await.done('getResponsavelSaraiva')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelSaraiva.persistResponsavelSaraiva()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-saraiva/list'
    )
  }
}
